<template>
  <div class="row">
    <div class="col-md-6">
      <reporting-profile-details/>
    </div>
    <div class="col-md-6">
      <reporting-profile-reports v-if="$auth.can({reporting_profile_report: 'read'}, 'permissions')"/>
    </div>
    <div class="col-md-12">
      <reporting-profile-accounts-table/>
    </div>
  </div>
</template>
<script>
import ReportingProfileReports from './ReportingProfileReports.vue';
import ReportingProfileAccountsTable from './ReportingProfileDetails/ReportingProfileAccountsTable.vue';
import ReportingProfileDetails from './ReportingProfileDetails/ReportingProfileDetails.vue';

export default {
  components: {
    ReportingProfileReports,
    ReportingProfileDetails,
    ReportingProfileAccountsTable
  },
};
</script>
<style></style>
